<template>
    <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
        <div class="contacts-9 py-lg-5 py-md-4">
            <div class="container">
                <div class="header-sec text-center mb-5">
                    <br />
                    <h1 class="title-w3l">
                        Login
                    </h1>
                </div>
                <div class="contactct-fm map-content-9">
                    <form class="pt-lg-4" onsubmit="return false;">
                        <label for="emailID">Email</label>
                        <input id="emailID" type="email" class="form-control" v-model="email" />
                        <br />
                        <label for="passwordID">Password</label>
                        <input id="passwordID" type="password" class="form-control" v-model="password" />
                        <br />

                        <div class="text-lg-center">
                            <button type="button" class="btn btn-primary btn-style mt-lg-5 mt-4"
                                v-on:click="loginUser">{{ working ? "Logging In..." : "Login" }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import Log from "../../Common/Client/Log";
import Info from "../../Common/Client/Info";
import Notification from "../../Common/Client/Notification";
import Globals from "../global";
import ClientGlobals from "~/clientGlobals";
import type { NuxtApp } from "#app";

const headers = useRequestHeaders(['cookie'])
const token = useCookie("TOKEN", { maxAge: Globals.ONE_YEAR, path: "/", sameSite: "lax" });
const route = useRoute();
const keywords = ref([""]);
const problems = ref("");
const name = ref("");
const link = ref("");
const working = ref(false);
const email = ref("");
const password = ref("");

function log(message: string, isInfo: boolean = true) {
    Log.log(message, route.path, isInfo, headers);
}

const {
    data,
} = await useAsyncData(async function (ctx?: NuxtApp | undefined): Promise<unknown> {
    if (token.value != null)
      ctx?.runWithContext(async() => await navigateTo("/dashboard", {replace: true}));
    return {};
});

useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Log into your account`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Login to manage your account`
    }
  ]
});

async function loginUser(): Promise<void> {
    try {
        working.value = true;
        log("User clicked 'Login'");
        log(`Email: ${email.value}`);
        log("Check for valid data");
        if (!email.value || !password.value) {
            log("Incomplete data");
            Notification.error("Error", "Incomplete data");
            return;
        }
        log("Send details to server");
        const loginModel = { email: email.value, password: password.value };
        const response: Response = await $fetch.raw(`/api/users/login`, {
            method: "POST",
            body: loginModel,
            headers,
            ignoreResponseError: true
        });
        const code: number = response.status;
        log(`code: ${code}`);
        if (code != 200) {
            log("If invalid, show errors");
            const errors = await response._data;
            errors.forEach(function (error: string) {
                Notification.error("Error", error);
            });
            return;
        }
        const userToken: string = await response._data;
        log("If successful, save token, go to main page");
        token.value = userToken;
        await navigateTo("/dashboard", {replace: true});
    }
    catch (ex) {
        log("Error occurred while trying to login", false);
        log(Info.prettifyIfPossible(ex), false);
        Log.reportError(headers);
    }
    finally {
        working.value = false;
    }
}
</script>

<style scoped></style>